import { render } from "./GeNumberObj.vue?vue&type=template&id=2e4ee006"
import script from "./GeNumberObj.vue?vue&type=script&lang=js"
export * from "./GeNumberObj.vue?vue&type=script&lang=js"

import "./GeNumberObj.vue?vue&type=style&index=0&id=2e4ee006&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__